/**
 * @generated SignedSource<<cc25edc435d6825101c0c0304054ca74>>
 * @relayHash e957879d91648786e0aa5b88026da986
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a2b1d1b203332ff4ea56e4a156664fc762378f1d3cc5cbd99f7f48c0e25e94aa

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareUpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
export type ReadingModeFullScreenQuery$variables = {
  containerId: string;
  createdAfter?: AGG$DateTime | null;
  createdBefore?: AGG$DateTime | null;
  isGoalUpdates: boolean;
  isProjectUpdates: boolean;
  isTagUpdates: boolean;
  isTeamUpdates: boolean;
  stateFilter?: TownsquareUpdateStateFilter | null;
  tagId: string;
  teamId: string;
};
export type ReadingModeFullScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalReadingModeInternals_GoalPagination" | "ProjectReadingModeInternals_ProjectPagination" | "TagReadingModeInternals_TagPagination" | "TeamReadingModeInternals_TeamPagination">;
};
export type ReadingModeFullScreenQuery = {
  response: ReadingModeFullScreenQuery$data;
  variables: ReadingModeFullScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdAfter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdBefore"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGoalUpdates"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectUpdates"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTagUpdates"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTeamUpdates"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v10 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v11 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "createdAfter"
},
v12 = {
  "kind": "Variable",
  "name": "createdBefore",
  "variableName": "createdBefore"
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v14 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v15 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v17 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "tagId",
    "variableName": "tagId"
  }
],
v18 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v14/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareUpdate"
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v23 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v24 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v25 = {
  "kind": "ScalarField",
  "name": "key"
},
v26 = {
  "kind": "ScalarField",
  "name": "name"
},
v27 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v28 = {
  "kind": "ScalarField",
  "name": "summary"
},
v29 = {
  "kind": "ScalarField",
  "name": "description"
},
v30 = [
  (v21/*: any*/),
  (v28/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v29/*: any*/),
              (v21/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v31 = {
  "kind": "ScalarField",
  "name": "url"
},
v32 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v33 = {
  "kind": "ScalarField",
  "name": "ari"
},
v34 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v35 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v36 = {
  "kind": "ScalarField",
  "name": "picture"
},
v37 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v38 = {
  "kind": "ScalarField",
  "name": "label"
},
v39 = {
  "kind": "ScalarField",
  "name": "start"
},
v40 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v41 = [
  (v38/*: any*/),
  (v40/*: any*/)
],
v42 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v41/*: any*/)
},
v43 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v44 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v37/*: any*/),
    (v26/*: any*/),
    (v21/*: any*/)
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v46 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v47 = [
  (v21/*: any*/)
],
v48 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v19/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v21/*: any*/),
          (v26/*: any*/),
          (v37/*: any*/),
          (v36/*: any*/)
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v47/*: any*/),
        "type": "AppUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v47/*: any*/),
        "type": "CustomerUser"
      }
    ]
  },
  (v21/*: any*/)
],
v49 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v41/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v51 = {
  "kind": "ScalarField",
  "name": "newTargetDateConfidence"
},
v52 = {
  "kind": "ScalarField",
  "name": "archived"
},
v53 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            (v52/*: any*/)
          ]
        }
      ]
    }
  ]
},
v54 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v55 = [
  (v19/*: any*/),
  (v36/*: any*/),
  (v26/*: any*/),
  (v37/*: any*/),
  (v21/*: any*/)
],
v56 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v55/*: any*/)
},
v57 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v55/*: any*/)
},
v58 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v59 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v60 = {
  "concreteType": "TownsquareHighlightConnection",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareHighlightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            (v29/*: any*/),
            (v19/*: any*/),
            (v21/*: any*/),
            (v54/*: any*/),
            (v56/*: any*/),
            (v57/*: any*/),
            (v45/*: any*/),
            (v58/*: any*/)
          ]
        }
      ]
    },
    (v59/*: any*/)
  ]
},
v61 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v26/*: any*/),
                (v21/*: any*/),
                (v37/*: any*/),
                (v36/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v46/*: any*/),
            (v45/*: any*/)
          ]
        }
      ]
    },
    (v59/*: any*/)
  ]
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "kind": "ScalarField",
          "name": "watching"
        },
        (v22/*: any*/),
        {
          "concreteType": "TownsquareProjectCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canWatchProject"
            },
            (v23/*: any*/),
            (v24/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "isPrivate"
        },
        {
          "concreteType": "TownsquareIconURIs",
          "kind": "LinkedField",
          "name": "iconUrl",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareThemeURIs",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "light"
                },
                {
                  "kind": "ScalarField",
                  "name": "dark"
                },
                {
                  "kind": "ScalarField",
                  "name": "transparent"
                }
              ]
            }
          ]
        },
        (v25/*: any*/),
        (v26/*: any*/),
        (v27/*: any*/),
        {
          "kind": "ScalarField",
          "name": "startDate"
        },
        {
          "concreteType": "TownsquareProjectUpdate",
          "kind": "LinkedField",
          "name": "latestUserUpdate",
          "plural": false,
          "selections": (v30/*: any*/)
        },
        (v31/*: any*/),
        {
          "concreteType": "TownsquareProjectCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            (v32/*: any*/)
          ]
        }
      ]
    },
    (v21/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v28/*: any*/),
    {
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v26/*: any*/),
        (v36/*: any*/),
        (v21/*: any*/),
        (v37/*: any*/)
      ]
    },
    (v42/*: any*/),
    {
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v43/*: any*/)
    },
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v31/*: any*/),
    {
      "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
      "kind": "LinkedField",
      "name": "viewers",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v48/*: any*/)
        }
      ]
    },
    {
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "oldState",
      "plural": false,
      "selections": (v43/*: any*/)
    },
    (v49/*: any*/),
    (v50/*: any*/),
    (v51/*: any*/),
    (v53/*: any*/),
    (v60/*: any*/),
    (v61/*: any*/)
  ],
  "type": "TownsquareProjectUpdate"
},
v63 = {
  "kind": "ScalarField",
  "name": "value"
},
v64 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v65 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v66 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v67 = [
  (v63/*: any*/)
],
v68 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v69 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v67/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v68/*: any*/)
  ]
},
v70 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v67/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v68/*: any*/)
  ]
},
v71 = {
  "kind": "ScalarField",
  "name": "type"
},
v72 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v73 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v74 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v73/*: any*/),
    (v71/*: any*/)
  ]
},
v75 = {
  "kind": "ScalarField",
  "name": "subType"
},
v76 = {
  "kind": "ScalarField",
  "name": "source"
},
v77 = {
  "kind": "ScalarField",
  "name": "time"
},
v78 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v77/*: any*/),
    (v21/*: any*/)
  ]
},
v79 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v26/*: any*/),
                (v71/*: any*/),
                (v75/*: any*/),
                (v52/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "externalEntityId"
                },
                (v76/*: any*/),
                (v78/*: any*/)
              ]
            },
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "snapshotValue",
              "plural": false,
              "selections": [
                (v63/*: any*/),
                (v21/*: any*/)
              ]
            },
            (v64/*: any*/),
            (v65/*: any*/)
          ]
        }
      ]
    }
  ]
},
v80 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v40/*: any*/)
  ]
},
v81 = [
  (v19/*: any*/),
  (v37/*: any*/),
  (v26/*: any*/),
  (v36/*: any*/),
  (v21/*: any*/)
],
v82 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v81/*: any*/)
},
v83 = {
  "kind": "ScalarField",
  "name": "score"
},
v84 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v81/*: any*/)
},
v85 = [
  (v45/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v63/*: any*/),
      (v83/*: any*/),
      (v38/*: any*/)
    ]
  },
  (v28/*: any*/),
  (v84/*: any*/),
  (v53/*: any*/),
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              (v21/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v54/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v45/*: any*/),
              (v58/*: any*/)
            ]
          }
        ]
      },
      (v59/*: any*/)
    ]
  },
  (v21/*: any*/)
],
v86 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v85/*: any*/)
},
v87 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v25/*: any*/)
  ]
},
v88 = [
  (v63/*: any*/),
  (v83/*: any*/)
],
v89 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v88/*: any*/)
},
v90 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v91 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v34/*: any*/),
          (v35/*: any*/),
          (v28/*: any*/),
          (v46/*: any*/),
          (v45/*: any*/),
          (v21/*: any*/)
        ]
      }
    ]
  }
],
v92 = [
  (v63/*: any*/),
  (v77/*: any*/),
  (v21/*: any*/)
],
v93 = [
  (v71/*: any*/),
  (v73/*: any*/)
],
v94 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isWatching"
        },
        (v22/*: any*/),
        {
          "concreteType": "TownsquareGoalCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canWatchGoal"
            },
            (v32/*: any*/),
            (v24/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDeleteUpdates"
            },
            (v23/*: any*/)
          ]
        },
        (v25/*: any*/),
        (v26/*: any*/),
        {
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "parentGoal",
          "plural": false,
          "selections": (v47/*: any*/)
        },
        {
          "concreteType": "TownsquareGoalIcon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            (v25/*: any*/),
            {
              "kind": "ScalarField",
              "name": "appearance"
            }
          ]
        },
        {
          "concreteType": "TownsquareMetricTargetConnection",
          "kind": "LinkedField",
          "name": "metricTargets",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareMetricTargetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareMetricTarget",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareMetric",
                      "kind": "LinkedField",
                      "name": "metric",
                      "plural": false,
                      "selections": [
                        (v21/*: any*/),
                        (v52/*: any*/)
                      ]
                    },
                    {
                      "concreteType": "TownsquareMetricTargetPeriodConnection",
                      "kind": "LinkedField",
                      "name": "metricTargetPeriods",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "TownsquareMetricTargetPeriodEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "TownsquareMetricTargetPeriod",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "TownsquareTargetDate",
                                  "kind": "LinkedField",
                                  "name": "date",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "TownsquareTargetDateRange",
                                      "kind": "LinkedField",
                                      "name": "dateRange",
                                      "plural": false,
                                      "selections": [
                                        (v39/*: any*/)
                                      ]
                                    }
                                  ]
                                },
                                (v63/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    (v21/*: any*/),
                    (v64/*: any*/),
                    (v65/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v66/*: any*/),
        (v52/*: any*/),
        {
          "concreteType": "TownsquareGoalType",
          "kind": "LinkedField",
          "name": "goalType",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalType",
              "kind": "LinkedField",
              "name": "successMeasure",
              "plural": false,
              "selections": [
                (v69/*: any*/),
                (v70/*: any*/),
                (v21/*: any*/)
              ]
            },
            (v21/*: any*/)
          ]
        },
        {
          "concreteType": "TownsquareGoalProgress",
          "kind": "LinkedField",
          "name": "progress",
          "plural": false,
          "selections": [
            (v71/*: any*/)
          ]
        },
        {
          "args": (v72/*: any*/),
          "concreteType": "TownsquareGoalConnection",
          "kind": "LinkedField",
          "name": "successMeasures",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoal",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v26/*: any*/),
                    (v52/*: any*/),
                    (v74/*: any*/),
                    (v79/*: any*/),
                    (v31/*: any*/),
                    (v66/*: any*/),
                    (v80/*: any*/),
                    (v82/*: any*/),
                    (v86/*: any*/),
                    (v22/*: any*/),
                    (v27/*: any*/),
                    {
                      "concreteType": "TownsquareGoalType",
                      "kind": "LinkedField",
                      "name": "goalType",
                      "plural": false,
                      "selections": [
                        (v69/*: any*/),
                        (v70/*: any*/),
                        (v87/*: any*/),
                        (v21/*: any*/)
                      ]
                    },
                    (v89/*: any*/),
                    {
                      "args": (v90/*: any*/),
                      "concreteType": "TownsquareGoalUpdateConnection",
                      "kind": "LinkedField",
                      "name": "updates",
                      "plural": false,
                      "selections": (v91/*: any*/),
                      "storageKey": "updates(first:10)"
                    }
                  ]
                },
                (v19/*: any*/)
              ]
            }
          ],
          "storageKey": "successMeasures(first:50)"
        },
        {
          "concreteType": "TownsquareGoalConnection",
          "kind": "LinkedField",
          "name": "subGoals",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoal",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v26/*: any*/),
                    (v52/*: any*/),
                    (v74/*: any*/),
                    {
                      "concreteType": "TownsquareGoalType",
                      "kind": "LinkedField",
                      "name": "goalType",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "kind"
                        },
                        (v21/*: any*/),
                        (v87/*: any*/)
                      ]
                    },
                    (v79/*: any*/),
                    (v31/*: any*/),
                    (v66/*: any*/),
                    (v80/*: any*/),
                    (v82/*: any*/),
                    (v86/*: any*/),
                    (v27/*: any*/),
                    (v89/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 30
                        }
                      ],
                      "concreteType": "TownsquareGoalUpdateConnection",
                      "kind": "LinkedField",
                      "name": "updates",
                      "plural": false,
                      "selections": (v91/*: any*/),
                      "storageKey": "updates(first:30)"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "args": (v90/*: any*/),
          "concreteType": "TownsquareGoalUpdateConnection",
          "kind": "LinkedField",
          "name": "updates",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalUpdateEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoalUpdate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v30/*: any*/)
                }
              ]
            }
          ],
          "storageKey": "updates(first:10)"
        },
        {
          "kind": "ScalarField",
          "name": "canPostUpdate"
        },
        (v27/*: any*/),
        {
          "kind": "ScalarField",
          "name": "canEditUpdate"
        }
      ]
    },
    (v34/*: any*/),
    (v35/*: any*/),
    (v45/*: any*/),
    (v28/*: any*/),
    {
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v88/*: any*/)
    },
    (v50/*: any*/),
    (v51/*: any*/),
    (v53/*: any*/),
    (v60/*: any*/),
    {
      "concreteType": "TownsquareGoalMetricUpdateConnection",
      "kind": "LinkedField",
      "name": "metricUpdate",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareGoalMetricUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareGoalMetricUpdate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareMetric",
                  "kind": "LinkedField",
                  "name": "metric",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v26/*: any*/),
                    (v71/*: any*/),
                    (v75/*: any*/),
                    (v52/*: any*/),
                    (v76/*: any*/),
                    (v78/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 100
                        },
                        {
                          "kind": "Literal",
                          "name": "sort",
                          "value": [
                            "TIME_DESC"
                          ]
                        }
                      ],
                      "concreteType": "TownsquareMetricValueConnection",
                      "kind": "LinkedField",
                      "name": "values",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "TownsquareMetricValueEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "TownsquareMetricValue",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": (v92/*: any*/)
                            }
                          ]
                        }
                      ],
                      "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                    }
                  ]
                },
                {
                  "concreteType": "TownsquareMetricValue",
                  "kind": "LinkedField",
                  "name": "newValue",
                  "plural": false,
                  "selections": (v92/*: any*/)
                },
                {
                  "concreteType": "TownsquareMetricValue",
                  "kind": "LinkedField",
                  "name": "oldValue",
                  "plural": false,
                  "selections": [
                    (v77/*: any*/),
                    (v21/*: any*/),
                    (v63/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "newStartValue"
                },
                {
                  "kind": "ScalarField",
                  "name": "newTargetValue"
                }
              ]
            }
          ]
        }
      ]
    },
    (v84/*: any*/),
    (v42/*: any*/),
    {
      "concreteType": "TownsquareGoalProgress",
      "kind": "LinkedField",
      "name": "newProgress",
      "plural": false,
      "selections": (v93/*: any*/)
    },
    (v44/*: any*/),
    (v46/*: any*/),
    {
      "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
      "kind": "LinkedField",
      "name": "viewers",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v48/*: any*/)
        }
      ]
    },
    (v31/*: any*/),
    (v33/*: any*/),
    (v61/*: any*/),
    {
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "oldState",
      "plural": false,
      "selections": (v88/*: any*/)
    },
    (v49/*: any*/),
    {
      "args": (v72/*: any*/),
      "concreteType": "TownsquareGoalBundledUpdateConnection",
      "kind": "LinkedField",
      "name": "bundledUpdates",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareGoalBundledUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareGoalUpdate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v85/*: any*/)
            },
            {
              "kind": "ScalarField",
              "name": "nodeMissingReason"
            },
            {
              "concreteType": "TownsquareGoal",
              "kind": "LinkedField",
              "name": "goal",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v26/*: any*/),
                {
                  "concreteType": "TownsquareGoalProgress",
                  "kind": "LinkedField",
                  "name": "progress",
                  "plural": false,
                  "selections": (v93/*: any*/)
                },
                (v79/*: any*/),
                (v31/*: any*/),
                (v66/*: any*/),
                (v80/*: any*/),
                (v82/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "bundledUpdates(first:50)"
    }
  ],
  "type": "TownsquareGoalUpdate"
},
v95 = [
  (v21/*: any*/),
  (v26/*: any*/)
],
v96 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": (v95/*: any*/)
    },
    {
      "alias": "newProjectState",
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v67/*: any*/)
    },
    (v34/*: any*/),
    (v35/*: any*/)
  ],
  "type": "TownsquareProjectUpdate"
},
v97 = {
  "kind": "InlineFragment",
  "selections": (v47/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v98 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v99 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v100 = [
  "createdBefore",
  "createdAfter",
  "containerId",
  "stateFilter"
],
v101 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": (v95/*: any*/)
    },
    {
      "alias": "newGoalState",
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v67/*: any*/)
    },
    (v34/*: any*/),
    (v35/*: any*/)
  ],
  "type": "TownsquareGoalUpdate"
},
v102 = [
  {
    "concreteType": "TownsquareUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v19/*: any*/),
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v19/*: any*/),
          (v62/*: any*/),
          (v94/*: any*/),
          (v96/*: any*/),
          (v101/*: any*/),
          (v97/*: any*/)
        ]
      },
      (v98/*: any*/)
    ]
  },
  (v99/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "ProjectReadingModeInternals_ProjectPagination"
          }
        ]
      },
      {
        "condition": "isGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "GoalReadingModeInternals_GoalPagination"
          }
        ]
      },
      {
        "condition": "isTeamUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "TeamReadingModeInternals_TeamPagination"
          }
        ]
      },
      {
        "condition": "isTagUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v17/*: any*/),
            "kind": "FragmentSpread",
            "name": "TagReadingModeInternals_TagPagination"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "ScalarField",
            "name": "projects_allWatchedProjectUpdatesCount"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "projects_allWatchedProjectUpdates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v62/*: any*/),
                      (v94/*: any*/),
                      (v96/*: any*/),
                      (v97/*: any*/)
                    ]
                  },
                  (v98/*: any*/)
                ]
              },
              (v99/*: any*/)
            ]
          },
          {
            "args": (v15/*: any*/),
            "filters": (v100/*: any*/),
            "handle": "connection",
            "key": "ProjectReadingModeInternals__projects_allWatchedProjectUpdates",
            "kind": "LinkedHandle",
            "name": "projects_allWatchedProjectUpdates"
          }
        ]
      },
      {
        "condition": "isGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "ScalarField",
            "name": "goals_allWatchedGoalUpdatesCount"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "goals_allWatchedGoalUpdates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v62/*: any*/),
                      (v94/*: any*/),
                      (v101/*: any*/),
                      (v97/*: any*/)
                    ]
                  },
                  (v98/*: any*/)
                ]
              },
              (v99/*: any*/)
            ]
          },
          {
            "args": (v15/*: any*/),
            "filters": (v100/*: any*/),
            "handle": "connection",
            "key": "GoalReadingModeInternals__goals_allWatchedGoalUpdates",
            "kind": "LinkedHandle",
            "name": "goals_allWatchedGoalUpdates"
          }
        ]
      },
      {
        "condition": "isTeamUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v16/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTeam",
            "plural": false,
            "selections": (v102/*: any*/)
          },
          {
            "args": (v16/*: any*/),
            "filters": [
              "teamId",
              "containerId",
              "createdAfter"
            ],
            "handle": "connection",
            "key": "TeamReadingModeInternals__statusUpdates_byTeam",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTeam"
          }
        ]
      },
      {
        "condition": "isTagUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v17/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTag",
            "plural": false,
            "selections": (v102/*: any*/)
          },
          {
            "args": (v17/*: any*/),
            "filters": [
              "tagId",
              "createdAfter",
              "containerId"
            ],
            "handle": "connection",
            "key": "TagReadingModeInternals__statusUpdates_byTag",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTag"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a2b1d1b203332ff4ea56e4a156664fc762378f1d3cc5cbd99f7f48c0e25e94aa",
    "metadata": {},
    "name": "ReadingModeFullScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e2d45e98b304835fd36cae9879065ed1";

export default node;
